function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScMusic = function SvgScMusic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--on-surface)",
    strokeWidth: 2,
    d: "M9 17a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm0 0V3.926a1 1 0 0 1 .923-.997l11-.846A1 1 0 0 1 22 3.08V16m0 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
    style: {
      stroke: "var(--on-surface)",
      strokeOpacity: 1
    },
    vectorEffect: "non-scaling-stroke"
  }));
};
export default SvgScMusic;